var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',_vm._g(_vm._b({attrs:{"variant":_vm.design},on:{"close":_vm.closeDropdown}},'b-dropdown',_vm.$attrs,false),_vm.mountEventListeners),[_c('template',{slot:"button-content"},[_vm._t("custom-text")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }